"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js/object/define-property");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.ajax = void 0;
var _axios = _interopRequireDefault(require("axios"));
var _config = require("./config");
var _utils = require("./utils");
/**
 * New instance of Ajax
 *
 * @type {Ajax} Ajax utility instance
 */
const ajax = exports.ajax = (0, _utils.createInstance)(_axios.default)('base', (0, _utils.createConfig)());
ajax.create = (0, _utils.createInstance)(_axios.default);
ajax.createError = _utils.createError;
ajax.instances = _utils.instances;
ajax.prepareData = _utils.prepareRequestData;
ajax.prepareDataTypes = _config.SUPPORTED_PREPARED_DATA_TYPES;
ajax.remove = _utils.removeInstance;
ajax.retrieve = _utils.retrieveInstance;
ajax.setupJwt = (0, _utils.setupCsrfAndJwt)(ajax);
var _default = exports.default = ajax;